import { useEffect, useState } from 'react';

const ScrollTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <a
            id="scrollUp"
            href="#hero-6"
            title="Back to top"
            style={{
                position: 'fixed',
                zIndex: 2147483647,
                display: visible ? 'block' : 'none',
            }}
        />
    );
};

export default ScrollTop;
